// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};


// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {

  let input = $(searchBoxId).val();
  
  $(suggestionElement).find('.bc-sf-search-suggestion-product-price').each(function(element){
    let compareVal = '$1.00';
    if($(this).text() == compareVal){
      $(this).text('');
    }
  });
  
  let suggest_collection_elements = $(suggestionElement).find('[data-group="collections"]').find('.bc-sf-search-suggestion-item a');
  
  if (suggest_collection_elements) {
    $.each(suggest_collection_elements, function(i, suggestion_link) {
      suggestion_link.innerText += ' Collection';
    });
  }  
           
  if (isNumber(input)) {           
     hideDoYouMeanLabel(suggestionElement, input);     
  }
};
           
function isNumber(input)
{
  return !isNaN(input);
}

function hideDoYouMeanLabel(suggestionElement, input)
{
  let suggestionDym = $(suggestionElement).find('.bc-sf-search-suggestion-dym');
  
  let didYouMeanString = $('[aria-label="Did you mean"]').text();
  
  $('[aria-label="Did you mean"]').hide();
  
  if (didYouMeanString.includes('Sorry, nothing found')) {
    $(suggestionElement).find('.bc-sf-search-suggestion-item').hide();
    
    let notFoundText = `<li class="bc-sf-search-suggestion-item bc-sf-search-suggestion-dym" aria-label="Did you mean"><p>Sorry, nothing found for "<strong>${input}</strong>"</p></li>`;
    
    $(suggestionDym).parent().append(notFoundText);
  }
}